// api.service.ts
import axios from "axios";
import { HttpRequest, HttpResponse } from "@/core/types/http.types";
import authService from "@/core/services/auth/auth.service";
import { HttpStatusCode } from "@/core/types/httpStatus.types";
import i18n from "@/core/plugins/i18n";
import { SET_ACCESS } from "../store/modules/user/user.module";

type NetworkProps = {
  request: HttpRequest;
};

class ApiService {
  private store: any;

  setStore(store: any) {
    this.store = store;
  }

  async request(
    { request }: NetworkProps,
    skipUnAuthorized = false
  ): Promise<HttpResponse> {
    try {
      const response = (await axios.request({
        timeout: 300000,
        method: request.method || "GET",
        url: request.url,
        headers: {
          "Content-Type": "application/json",
          lang: "fa",
          "Access-Control-Allow-Origin": "*",
          "Accept-Language": "fa",
          ...request.headers,
        },
        params: ["GET", "DELETE"].includes(request.method || "GET")
          ? request.data
          : {},
        data: ["PUT", "POST"].includes(request.method || "GET")
          ? request.data
          : {},
      })) as HttpResponse;

      return response;
    } catch (error: any) {
      const {
        response: { status = "", statusText = "", headers = {}, data = null },
      } = error;

      if (status === HttpStatusCode.UNAUTHORIZED && !skipUnAuthorized) {
        authService.destroyAuth();
        window.location.href = "/login";
      } else if (status === HttpStatusCode.NO_ACCESS) {
        this.store.commit(SET_ACCESS, false);
      }

      const message = data.errors
        ? data.errors.non_field_errors[0] || data.errors[0]
        : data.message
        ? data.message
        : i18n.t("main_error");

      throw {
        status,
        statusText,
        headers,
        message: message,
      } as HttpResponse;
    }
  }
}

const apiService = new ApiService();
export default apiService;
